import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

function timeAgo(date) {
  if (!date) return 'Nunca acessou';
  const d = (Date.now()-new Date(date))/1000/86400;
  if (d<1) return 'Hoje'; if (d<2) return 'Ontem'; return `Há ${Math.floor(d)} dias`;
}

function OperacaoDetalhe({ alunoId, operacaoId, token, alertasOp }) {
  const [detalhe, setDetalhe] = useState(null);
  const [expandidas, setExpandidas] = useState({});

  useEffect(() => {
    api.get(`/mentor/alunos/${alunoId}/operacoes/${operacaoId}/progresso`, token).then(setDetalhe);
  }, [alunoId, operacaoId, token]);

  if (!detalhe) return <div style={{padding:'12px 18px',fontSize:12,color:'#6B7289'}}>Carregando...</div>;

  const { fases, fasesPuladas } = detalhe;
  const toggleFase = (faseId) => setExpandidas(prev => ({ ...prev, [faseId]: !prev[faseId] }));

  return (
    <div style={{borderTop:'0.5px solid #E4E6EF'}}>
      {fases.map(f => {
        const pulada = (fasesPuladas||[]).includes(f.id);
        const feitas = pulada ? f.tarefas.length : f.tarefas.filter(t => t.concluido).length;
        const total = f.tarefas.length;
        const pct = pulada ? 100 : Math.round(feitas / total * 100);
        const completa = pct === 100;
        const emAndamento = !completa && feitas > 0;
        const expandida = expandidas[f.id];
        const atrasada = alertasOp?.some(a => a.fase_id === f.id || a.fase_nome === f.nome);
        const statusIcon = pulada ? '⏭' : completa ? '✅' : emAndamento ? '🔄' : '⬜';
        const statusColor = atrasada ? '#D63B3B' : pulada ? '#E6A817' : completa ? '#0FA36B' : emAndamento ? '#1A2ECC' : '#9095A8';
        const bgColor = atrasada ? '#FFF5F5' : pulada ? '#FFFBEB' : completa ? '#F6FBF8' : emAndamento ? '#F0F3FF' : '#FAFBFE';

        return (
          <div key={f.id} style={{borderBottom:'0.5px solid #E4E6EF'}}>
            <div onClick={()=>toggleFase(f.id)}
              style={{display:'flex',alignItems:'center',gap:12,padding:'12px 18px',cursor:'pointer',background:bgColor}}
              onMouseEnter={e=>e.currentTarget.style.filter='brightness(.97)'}
              onMouseLeave={e=>e.currentTarget.style.filter='none'}>
              <span style={{fontSize:16,flexShrink:0}}>{atrasada ? '⚠️' : statusIcon}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                  <span style={{fontSize:12,fontWeight:600,color: atrasada ? '#D63B3B' : '#0B0E1A'}}>Fase {f.id} · {f.nome}</span>
                  {f.opcional && <span style={{fontSize:9,fontWeight:600,color:'#E6A817',background:'#FEF5E4',padding:'1px 6px',borderRadius:99}}>Opcional</span>}
                  {atrasada && <span style={{fontSize:9,fontWeight:700,color:'#D63B3B',background:'#FDEAEA',padding:'1px 6px',borderRadius:99}}>ATRASADA</span>}
                </div>
                {emAndamento && !atrasada && (
                  <div style={{marginTop:4}}>
                    <div style={{height:3,background:'#E4E6EF',borderRadius:99,overflow:'hidden',width:120}}>
                      <div style={{height:'100%',background:'#1A2ECC',width:pct+'%',borderRadius:99}} />
                    </div>
                  </div>
                )}
              </div>
              <div style={{display:'flex',alignItems:'center',gap:10,flexShrink:0}}>
                <span style={{fontSize:12,fontWeight:700,color:statusColor}}>{pulada ? 'Pulada' : `${feitas}/${total}`}</span>
                <span style={{fontSize:11,color:statusColor,fontWeight:600}}>{pulada?'':pct+'%'}</span>
                <span style={{fontSize:10,color:'#9095A8',transform:expandida?'rotate(180deg)':'none',transition:'.2s'}}>▼</span>
              </div>
            </div>

            {expandida && (
              <div style={{background:'#fff',borderTop:'0.5px solid #E4E6EF'}}>
                {f.tarefas.map(t => {
                  const done = pulada || t.concluido;
                  return (
                    <div key={t.id} style={{display:'flex',alignItems:'flex-start',gap:10,padding:'10px 18px 10px 48px',borderBottom:'0.5px solid #F4F5F9'}}>
                      <div style={{width:16,height:16,borderRadius:4,background:done?'#0FA36B':'transparent',border:done?'none':'1.5px solid #D0D3E0',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:1}}>
                        {done && <svg width="9" height="9" viewBox="0 0 12 10" fill="none" stroke="#fff" strokeWidth="2.5"><polyline points="1,5 4,8 11,1"/></svg>}
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:12,color:done?'#6B7289':'#0B0E1A',textDecoration:done?'line-through':'none'}}>{t.descricao}</div>
                        {t.observacao && (
                          <div style={{fontSize:11,color:'#8C5E00',background:'#FFFBEB',padding:'4px 8px',borderRadius:5,marginTop:4,borderLeft:'2px solid #E6A817'}}>
                            📝 {t.observacao}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default function MentorAlunoDetalhe() {
  const { id } = useParams();
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [alertas, setAlertas] = useState([]);
  const [opExpandida, setOpExpandida] = useState(null);
  const [abaOps, setAbaOps] = useState('ativas');
  const [opArquivadas, setOpArquivadas] = useState([]);
  const [criandoOp, setCriandoOp] = useState(false);
  const [editandoAluno, setEditandoAluno] = useState(false);
  const [formAluno, setFormAluno] = useState({});
  const [turmas, setTurmas] = useState([]);
  const [salvandoAluno, setSalvandoAluno] = useState(false);
  const [nomeOp, setNomeOp] = useState('');
  const [descOp, setDescOp] = useState('');
  const [salvandoOp, setSalvandoOp] = useState(false);
  const navigate = useNavigate();

  const carregar = () => {
    api.get(`/mentor/alunos/${id}`, token).then(setData);
    api.get(`/mentor/alunos/${id}/alertas`, token).then(setAlertas).catch(()=>{});
    api.get(`/mentor/alunos/${id}/operacoes-arquivadas`, token).then(setOpArquivadas).catch(()=>{});
  };
  useEffect(() => { api.get('/turmas', token).then(setTurmas).catch(()=>{}); }, [token]);

  useEffect(() => { carregar(); }, [id, token]);

  const salvarAluno = async (e) => {
    e.preventDefault();
    setSalvandoAluno(true);
    try {
      const { acesso, acessoOrig, ...dados } = formAluno;
      if (acesso !== acessoOrig) { // só mexe no acesso se o mentor mudou
        dados.colaborador = acesso !== 'aluno';
        dados.admin = acesso === 'admin';
      }
      await api.patch(`/mentor/alunos/${id}`, dados, token);
      setEditandoAluno(false);
      carregar();
    } catch(err) { alert('Erro ao salvar'); }
    finally { setSalvandoAluno(false); }
  };

  const enviarNovaSenha = async () => {
    if (!window.confirm(`Enviar por e-mail um link para ${aluno.nome} criar uma nova senha?`)) return;
    try {
      const r = await api.post(`/senha/enviar-aluno/${id}`, {}, token);
      alert(r.mensagem);
    } catch (err) { alert(err.message); }
  };

  const criarOperacao = async (e) => {
    e.preventDefault();
    setSalvandoOp(true);
    try {
      await api.post('/mentor/operacoes', { aluno_id: id, nome: nomeOp, descricao: descOp }, token);
      setCriandoOp(false); setNomeOp(''); setDescOp('');
      carregar();
    } catch(err) { alert('Erro ao criar operação'); }
    finally { setSalvandoOp(false); }
  };

  if (!data) return <div style={{padding:32,color:'#6B7289'}}>Carregando perfil...</div>;

  const { aluno, operacoes, conquistas } = data;
  const conquistasUnicas = conquistas.reduce((acc, c) => {
    if (!acc[c.tipo_id]) acc[c.tipo_id] = { ...c, count: 1 };
    else { acc[c.tipo_id].count++; if (c.desbloqueada_em) acc[c.tipo_id].desbloqueada_em = c.desbloqueada_em; }
    return acc;
  }, {});
  const conquistasArr = Object.values(conquistasUnicas);
  const tiposDesbloqueados = conquistasArr.filter(c=>c.desbloqueada_em).length;
  const melhorOp = operacoes.length > 0 ? Math.max(...operacoes.map(o=>o.pct||0)) : 0;

  const toggleOp = (opId) => setOpExpandida(prev => prev === opId ? null : opId);

  return (
    <div style={{padding:'28px 32px'}}>
      <button onClick={()=>navigate('/mentor/alunos')} style={{marginBottom:20,fontSize:12,background:'none',border:'none',cursor:'pointer',color:'#6B7289'}}>← Voltar</button>

      {/* Modal Editar Aluno */}
      {editandoAluno && aluno && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100}}>
          <div className="card" style={{width:480,borderRadius:20}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:20}}>Editar Aluno</div>
            <form onSubmit={salvarAluno}>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:12,color:'#6B7289',display:'block',marginBottom:4}}>Tipo de acesso</label>
                <select className="input-field" value={formAluno.acesso||'aluno'} onChange={e=>setFormAluno(f=>({...f,acesso:e.target.value}))}
                  style={{width:'100%',padding:'10px 12px',border:'1px solid #E4E6EF',borderRadius:8,fontSize:13,background:'#fff'}}>
                  <option value="aluno">Aluno</option>
                  <option value="colaborador">Colaborador (equipe SVSLOG)</option>
                  <option value="admin">Colaborador + Administrador</option>
                </select>
                <div style={{fontSize:10,color:'#9095A8',marginTop:3}}>Administrador vê as cotações de todos e pode excluir. A pessoa precisa sair e entrar de novo para valer.</div>
              </div>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:12,color:'#6B7289',display:'block',marginBottom:4}}>Nome</label>
                <input className="input-field" value={formAluno.nome||''} onChange={e=>setFormAluno(f=>({...f,nome:e.target.value}))} />
              </div>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:12,color:'#6B7289',display:'block',marginBottom:4}}>Turma</label>
                <select className="input-field" value={formAluno.turma_id||''} onChange={e=>setFormAluno(f=>({...f,turma_id:e.target.value||null}))}
                  style={{width:'100%',padding:'10px 12px',border:'1px solid #E4E6EF',borderRadius:8,fontSize:13,background:'#fff'}}>
                  <option value="">Sem turma</option>
                  {turmas.map(t=><option key={t.id} value={t.id}>{t.nome}</option>)}
                </select>
              </div>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:12,color:'#6B7289',display:'block',marginBottom:4}}>Data de Nascimento</label>
                <input className="input-field" type="date" value={formAluno.data_nascimento||''} onChange={e=>setFormAluno(f=>({...f,data_nascimento:e.target.value||null}))} />
              </div>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:12,color:'#6B7289',display:'block',marginBottom:4}}>Vencimento do Plano</label>
                <input className="input-field" type="date" value={formAluno.data_vencimento||''} onChange={e=>setFormAluno(f=>({...f,data_vencimento:e.target.value||null}))} />
                <div style={{fontSize:10,color:'#9095A8',marginTop:3}}>Após esta data o aluno não conseguirá mais acessar</div>
              </div>
              <div style={{display:'flex',gap:16,marginBottom:12,flexWrap:'wrap'}}>
                <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,cursor:'pointer'}}>
                  <input type="checkbox" checked={!!formAluno.no_ranking} onChange={e=>setFormAluno(f=>({...f,no_ranking:e.target.checked}))} />
                  Aparece no ranking
                </label>
                <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,cursor:'pointer'}}>
                  <input type="checkbox" checked={!!formAluno.ativo} onChange={e=>setFormAluno(f=>({...f,ativo:e.target.checked}))} />
                  Conta ativa (desmarcar = bloquear acesso)
                </label>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}>
                <button type="button" className="btn-ghost" onClick={()=>setEditandoAluno(false)}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={salvandoAluno}>{salvandoAluno?'Salvando...':'Salvar →'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Nova Operação */}
      {criandoOp && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100}}>
          <div className="card" style={{width:460,borderRadius:20}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:6}}>Nova Operação para {aluno?.nome}</div>
            <div style={{fontSize:12,color:'#6B7289',marginBottom:20}}>A operação será criada e ficará disponível na Jornada do aluno.</div>
            <form onSubmit={criarOperacao}>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Nome da operação</label>
                <input className="input-field" placeholder="Ex: Fones Bluetooth — Mercado Livre" value={nomeOp} onChange={e=>setNomeOp(e.target.value)} required autoFocus />
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Observações (opcional)</label>
                <textarea className="input-field" rows={3} placeholder="NCM, fornecedor, instruções..." value={descOp} onChange={e=>setDescOp(e.target.value)} style={{resize:'vertical'}} />
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" className="btn-ghost" onClick={()=>setCriandoOp(false)}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={salvandoOp}>{salvandoOp?'Criando...':'Criar operação →'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'1fr 280px',gap:20,alignItems:'start'}}>
        <div>
          {/* CARD DO ALUNO */}
          <div className="card" style={{marginBottom:16}}>
            <div style={{display:'flex',alignItems:'center',gap:14,marginBottom:16}}>
              <div style={{width:48,height:48,borderRadius:12,background:'#EBF0FF',color:'#1028A0',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:16}}>
                {aluno.nome.split(' ').map(n=>n[0]).slice(0,2).join('').toUpperCase()}
              </div>
              <div>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                <div style={{fontSize:18,fontWeight:700}}>{aluno.nome}</div>
                {(aluno.colaborador||aluno.admin) && <span style={{fontSize:10,fontWeight:700,color:'#0B3D6B',background:'#E6EEF8',padding:'2px 8px',borderRadius:99}}>{aluno.admin?'COLABORADOR + ADMIN':'COLABORADOR'}</span>}
                <button onClick={()=>{setFormAluno({nome:aluno.nome,turma_id:aluno.turma_id||'',no_ranking:aluno.no_ranking,ativo:aluno.ativo!==false,data_nascimento:aluno.data_nascimento?aluno.data_nascimento.split('T')[0]:'',data_vencimento:aluno.data_vencimento?aluno.data_vencimento.split('T')[0]:'',acesso:aluno.admin?'admin':(aluno.colaborador?'colaborador':'aluno'),acessoOrig:aluno.admin?'admin':(aluno.colaborador?'colaborador':'aluno')});setEditandoAluno(true);}}
                  style={{background:'#EEF1FF',border:'none',borderRadius:6,padding:'4px 10px',fontSize:11,color:'#1A2ECC',cursor:'pointer'}}>
                  ✏️ Editar
                </button>
                <button onClick={enviarNovaSenha}
                  style={{background:'#F4F5F9',border:'none',borderRadius:6,padding:'4px 10px',fontSize:11,color:'#6B7289',cursor:'pointer'}}>
                  🔑 Enviar nova senha
                </button>
              </div>
                <div style={{fontSize:12,color:'#6B7289'}}>{aluno.email} · {aluno.turma||'Sem turma'}</div>
                <div style={{fontSize:11,color:'#9095A8',marginTop:2}}>{timeAgo(aluno.ultimo_acesso)}</div>
              {aluno.data_vencimento && (
                <div style={{fontSize:11,marginTop:4,fontWeight:600,
                  color: new Date(aluno.data_vencimento) < new Date() ? '#D63B3B' : 
                         new Date(aluno.data_vencimento) < new Date(Date.now()+30*86400000) ? '#E6A817' : '#0FA36B'}}>
                  {new Date(aluno.data_vencimento) < new Date() ? '⚠️ Plano vencido em ' : 
                   new Date(aluno.data_vencimento) < new Date(Date.now()+30*86400000) ? '⚠️ Vence em ' : '✓ Plano válido até '}
                  {new Date(aluno.data_vencimento).toLocaleDateString('pt-BR')}
                </div>
              )}
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
              {[['Melhor operação',melhorOp+'%'],['Operações',operacoes.length],['Conquistas',tiposDesbloqueados+'/'+conquistasArr.length]].map(([l,v])=>(
                <div key={l} style={{background:'#F4F5F9',borderRadius:10,padding:12}}>
                  <div style={{fontSize:10,color:'#6B7289',fontWeight:500,textTransform:'uppercase',letterSpacing:'.06em'}}>{l}</div>
                  <div style={{fontSize:20,fontWeight:700,marginTop:4}}>{v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ALERTAS DO ALUNO */}
          {alertas.length > 0 && (
            <div style={{background:'#FDEAEA',border:'1px solid #FCA5A5',borderRadius:10,padding:'12px 16px',marginBottom:16}}>
              <div style={{fontSize:12,fontWeight:700,color:'#D63B3B',marginBottom:4}}>⚠️ {alertas.length} operaç{alertas.length>1?'ões com prazos':'ão com prazo'} vencido{alertas.length>1?'s':''}</div>
              <div style={{fontSize:11,color:'#D63B3B'}}>{alertas.reduce((s,a)=>s+a.fases.length,0)} fase{alertas.reduce((s,a)=>s+a.fases.length,0)>1?'s atrasadas':' atrasada'} no total</div>
            </div>
          )}

          {/* OPERAÇÕES */}
          <div className="card" style={{padding:0,overflow:'hidden'}}>
            <div style={{padding:'12px 18px',borderBottom:'0.5px solid #E4E6EF',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:8}}>
              <div style={{display:'flex',gap:6}}>
                <button onClick={()=>setAbaOps('ativas')} style={{fontSize:11,fontWeight:600,padding:'4px 12px',borderRadius:6,border:'none',cursor:'pointer',background:abaOps==='ativas'?'#1A2ECC':'#F4F5F9',color:abaOps==='ativas'?'#fff':'#6B7289'}}>
                  Ativas ({operacoes.length})
                </button>
                <button onClick={()=>setAbaOps('arquivadas')} style={{fontSize:11,fontWeight:600,padding:'4px 12px',borderRadius:6,border:'none',cursor:'pointer',background:abaOps==='arquivadas'?'#6B7289':'#F4F5F9',color:abaOps==='arquivadas'?'#fff':'#6B7289'}}>
                  Arquivadas ({opArquivadas.length})
                </button>
              </div>
              <button className="btn-primary" style={{fontSize:11,padding:'5px 12px'}} onClick={()=>setCriandoOp(true)}>
                + Nova operação
              </button>
            </div>
            {abaOps==='ativas' && operacoes.length===0 && (
              <div style={{padding:24,textAlign:'center',color:'#6B7289',fontSize:13}}>Nenhuma operação criada ainda.</div>
            )}
            {abaOps==='arquivadas' && opArquivadas.length===0 && (
              <div style={{padding:24,textAlign:'center',color:'#6B7289',fontSize:13}}>Nenhuma operação arquivada.</div>
            )}
            {(abaOps==='ativas' ? operacoes : opArquivadas).map(op => {
              // alertas agora é array de {operacao_id, fases:[nome1, nome2]}
              const alertaOp = alertas.find(a => String(a.operacao_id) === String(op.id));
              const temAlerta = !!alertaOp;
              const fasesAtrasadas = alertaOp?.fases || [];
              return (
                <div key={op.id} style={{borderBottom:'0.5px solid #E4E6EF'}}>
                  <div onClick={()=>toggleOp(op.id)}
                    style={{padding:'14px 18px',cursor:'pointer',background:opExpandida===op.id?'#F7F8FC':'#fff',transition:'.1s',
                      borderLeft: temAlerta ? '3px solid #D63B3B' : '3px solid transparent'}}
                    onMouseEnter={e=>e.currentTarget.style.background='#F7F8FC'}
                    onMouseLeave={e=>e.currentTarget.style.background=opExpandida===op.id?'#F7F8FC':'#fff'}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:'flex',alignItems:'center',gap:8}}>
                          <span style={{fontSize:14,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{op.nome}</span>
                          {temAlerta && <span style={{fontSize:10,fontWeight:700,color:'#D63B3B',background:'#FDEAEA',padding:'2px 6px',borderRadius:4,flexShrink:0}}>⚠️ Atrasada</span>}
                          <span style={{fontSize:10,color:'#9095A8',transform:opExpandida===op.id?'rotate(180deg)':'none',transition:'.2s',flexShrink:0}}>▼</span>
                        </div>
                        {op.descricao && <div style={{fontSize:11,color:'#6B7289',marginTop:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{op.descricao}</div>}
                      </div>
                      <span style={{fontSize:13,fontWeight:700,color:op.pct===100?'#0FA36B':temAlerta?'#D63B3B':op.pct>0?'#1A2ECC':'#9095A8',flexShrink:0,marginLeft:8}}>{op.pct}%</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill" style={{width:op.pct+'%',background:op.pct===100?'#0FA36B':temAlerta?'#D63B3B':'#1A2ECC'}} />
                    </div>
                    <div style={{fontSize:11,color:temAlerta?'#D63B3B':'#6B7289',marginTop:5}}>{op.feitas} de {op.total} tarefas</div>
                    {temAlerta && fasesAtrasadas.length > 0 && (
                      <div style={{fontSize:10,color:'#D63B3B',marginTop:3}}>
                        ⚠️ {fasesAtrasadas.join(', ')}
                      </div>
                    )}
                  </div>
                  {opExpandida === op.id && (
                    <OperacaoDetalhe alunoId={id} operacaoId={op.id} token={token} alertasOp={[]} />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CONQUISTAS */}
        <div>
          <div className="card" style={{padding:0,overflow:'hidden'}}>
            <div style={{padding:'12px 14px',borderBottom:'0.5px solid #E4E6EF',fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em'}}>
              Conquistas
            </div>
            <div style={{padding:14,display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
              {conquistasArr.map(c=>(
                <div key={c.tipo_id} title={c.nome} style={{textAlign:'center',opacity:c.desbloqueada_em?1:.3,filter:c.desbloqueada_em?'none':'grayscale(1)'}}>
                  <div style={{fontSize:24}}>{c.icone}</div>
                  <div style={{fontSize:9,color:'#6B7289',marginTop:3,lineHeight:1.2}}>{c.nome}</div>
                  {c.count > 1 && (
                    <div style={{fontSize:9,fontWeight:700,color:'#1A2ECC',background:'#EEF1FF',borderRadius:99,padding:'1px 6px',marginTop:3,display:'inline-block'}}>
                      ×{c.count}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
